export { default as MainArea } from './MainArea';



// WEBPACK FOOTER //
// ./src/actions/index.js